<template>
    <div>
        <div class="section-title">
            {{ selected_album.name }} <i class="fa fa-spinner fa-spin" v-if="$store.state.submitting"></i>
            <span class="small-txt text-white" v-if="selected_album.album_date != null">( {{ selected_album.album_date }} )</span>
            <div class="pull-right">
                <a class="btn-back text-info" href="#" @click.prevent.stop="backToAlbumList">
                    <i class="fas fa-chevron-circle-left"></i> {{ trans[locale].btn_back }}
                </a>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-sm-6 col-lg-8">
                {{ selected_album.description }}
            </div>
            <div class="col-sm-6 col-lg-4">
                <div class="pull-right">
                    <multiselect
                            :options="sorting_options"
                            v-model="sorting"
                            track-by="key"
                            label="name"
                            :preselect-first="true"
                            :searchable="false"
                            :allow-empty="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :multiple="false"
                            style="min-width:100px"
                    >
                    </multiselect>
                </div>
                <div class="pull-right mr-2">
                    <div class="d-inline-block form-control-plaintext">
                        {{ trans[locale].sort_by }}
                    </div>
                </div>
            </div>
        </div>
        <thumb-listing :url="media_url"
                       init_table_class="digitalch"
                       init_list_class="thumb-list"
                       :ignore_total_string="false"
                       :extract_hook_success_callback=true
                       element_id="selector_media"
                       :ignore_query_string="true"
                       v-show="!$store.state.submitting"
        >
            <template slot="scopeListing" slot-scope="scopeListing">
                <div class="list-item draggable valign_top draggable-item"
                     v-for="(row, key) in listingRecords.selector_media.data">
                    <div class="edit-layer">
                        <label class="custom-cb"
                        >
                            <input type="checkbox"
                                   v-model="row.selected"
                                   @click="toggleSelectedItem(row)"
                            ><span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="thumb">
                        <div class="thumb-overlay"><div class="title">{{ row.name }}</div></div>
                        <div v-if="row.is_video && row.is_ready" class="icon-video"><i class="fas fa-play-circle"></i></div>
                        <img :src="row.thumbnail" class="d-block">
                    </div>
                </div>
            </template>
        </thumb-listing>
    </div>
</template>

<script>
    import { helperTableSelectAll } from "../../mixins/helper.common";

    export default {
        mixins: [ helperTableSelectAll ],
        name: "MediaSelector",
        data() {
            return Object.assign({
                trans: {
                    'zh-HK' : {
                        btn_back: '返回',
                        sort_by: '排序:',
                    },
                    'en' : {
                        btn_back: 'back',
                        sort_by: 'Sort by:',
                    },
                },
                listingRecords: {
                    selector_media: {
                        data: [],
                    }
                },
                selected_media: this.init_selected_media,
                selected_album: {},
                query_str: '',
                category_keyword:'',
                keyword: '',
                sorting_options: this.init_sorting_options,
                sorting: this.init_sorting,
            }, { locale: window.locale })
        },
        props: {
            init_sorting_options: {
                required:false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_sorting: {
                required:false,
                type: Object,
                default: () => {
                    return {};
                }
            },
            init_selected_media: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            }
        },
        beforeMount() {
            window.eventHub.$off('pull-listing-data', this.pullListingData);
            window.eventHub.$off('retrieve-media-list', this.fetchMediaList);
        },
        mounted() {
            let table_id = 'selector_media';
            this._defineTableElement(table_id);
            window.eventHub.$on('pull-listing-data', this.pullListingData);
            window.eventHub.$on('retrieve-media-list', this.fetchMediaList);
        },
        computed: {
            media_url() {
                let url = _.isUndefined(this.selected_album.media_list_url)
                    ? ''
                    : this.selected_album.media_list_url;

                if (url != '')
                {
                    if (!_.isUndefined(this.sorting.key) &&
                        this.sorting.key != 'default')
                    {
                        if (url.includes('?')) {
                            url += '&sort=' + this.sorting.key;
                        } else {
                            url += '?sort=' + this.sorting.key;
                        }
                    }
                    if (url.includes('?')) {
                        url += '&keyword=' + this.keyword;
                    } else {
                        url += '?keyword=' + this.keyword;
                    }
                }
                return url;
            }
        },
        methods: {
            pullListingData(table_data, element_id) {
                let self = this;
                if (!_.isUndefined(element_id)) {
                    let tempTableData = self._assignSelected(element_id, table_data, 'key');

                    self.listingRecords[element_id] = self._cloneObject(tempTableData);
                    let selectedMediaKey = this._pluckByKey(self.selected_media, 'key');
                    let custom_index = 0;
                    _.forEach(self.listingRecords[element_id].data, (record, index) => {
                        if (_.includes(selectedMediaKey, record.key)) {
                            self.listingRecords[element_id].data[index].selected = true;
                            self.listingRecords[element_id].data[index].ordering = custom_index;
                            custom_index++;
                        }
                    });
                    return self.listingRecords[element_id];
                }
                return [];
            },
            fetchMediaList(param) {
                if (!_.isUndefined(param.album)) {
                    this.selected_album = param.album;
                }
                if (!_.isUndefined(param.keyword)) {
                    this.keyword = param.keyword;
                }
                if (!_.isUndefined(param.category_keyword)) {
                    this.category_keyword = param.category_keyword;
                }
            },
            backToAlbumList() {
                window.eventHub.$emit('update-keyword', this.category_keyword);
                window.eventHub.$emit('show-media-listing', false);
            },
            toggleSelectedItem(row) {
                let self = this;
                let new_selected_item = [];
                let existing = false;

                _.forEach(self.selected_media, (record) => {
                    if (record.key == row.key) {
                        existing = true;
                    } else {
                        new_selected_item.push(record);
                    }
                });
                if (!existing) {
                    new_selected_item.push(row);
                }

                self.selected_media = new_selected_item;
                let param = {
                    selected_media: self.selected_media
                };
                window.eventHub.$emit('set-selected-media', self._cloneObject(param));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DigitalChannelMediaPicker/MediaSelector.vue